<template>
  <md-dialog class="updloadPdf-form-dialog" :md-closed="closeDialog" :md-opened="openDialog" :md-close-on-esc="false"
             :md-click-outside-to-close="false"
             :md-active.sync="options.showUploadPdfForm">
    <md-dialog-title class="mt-20" style="font-size: 2rem;">
      <div class="tab-header-grid">
        <div class="tab-title" style=" padding: 5px;">
          {{options.Lang.FileUpload}}
        </div>
        <div class="tab-info-box">
          <SmallInfoBox title="Angebot" :content="trip_details_json && trip_details_json.data ? trip_details_json.data.attributes.alias : ''" />
        </div>

        <div class="tab-info-box">
          <SmallInfoBox :title="'Nezasa ID'" :content="trip ? trip.nezasa_id : ''" :copy="true" />
        </div>
      </div>
      <div class="tab-buttons">
        <button class="tab-btn" :class="{ active: tabChoice === 'trip_documents'}" @click="tabChoice = 'trip_documents'">
          {{ options.Lang.pdf_modal.trip_documents }}
        </button>
        <button class="tab-btn" :class="{ active: tabChoice === 'general_documents'}" @click="tabChoice = 'general_documents'">
          {{ options.Lang.pdf_modal.general_documents }}
        </button>
        <button class="tab-btn" :class="{ active: tabChoice === 'upload_documents'}" @click="tabChoice = 'upload_documents'">
          {{ options.Lang.pdf_modal.file_upload }}
        </button>
      </div>
      <section v-if="options.isUploading" class="loading_spinner">
        <div v-if="options.isUploading" class="ladebalken">
          <div class="custom-spinner"></div>
        </div>
      </section>
    </md-dialog-title>
    <md-dialog-content class="pdf-upload-dialog-content">
      <transition name="tab-slide-fade" mode="out-in" @before-enter="beforeEnter" @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave" @leave="leave" @after-leave="afterLeave">
        <div :key="tabChoice">
          <div v-if="tabChoice === 'trip_documents'">
            <div v-if="(pdfs && isLoaded)">
              <table class="tableclass2-timeline" style="width: 100%;">
                <tr>
                  <td style="width: 40%;padding-left: 20px;" class="categorie">
                    {{options.Lang.Kategorie}}
                  </td>
                  <td style="width: 30%; padding: 0;" class="name1">
                    {{options.Lang.Name}}
                  </td>
                  <td style="width: 30%;padding-left: 20px;" class="action">

                  </td>
                </tr>

              </table>
              <table class="formTD"  v-for="(cat, index) in categories" :key="index" style="width: 100%;">
                <tr :class="(pdf.name == cat.name ? '' : 'none' )" v-for="(pdf, index) in pdfs" :key="index">
                  <td style="width: 40%; padding-left: 20px;">
                    {{ pdf.name }}
                  </td>
                  <td style="width: 30%;">{{ pdf.pdfName + "." + pdf.pdf.split(".")[1] }}</td>
                  <td style="width: 30%;">
                    <a v-bind:href="'./' + pdf.pdf" target="_blank">
                      <div style="float: right; height: 40px; padding-top: 7px;">
                        <md-icon style="color:black;">travel_explore</md-icon>
                      </div>
                    </a>
                    <div style="float: right; height: 40px; padding-top: 7px;" v-bind:id="pdf.id" @click="removePDF(pdf.id)">
                      <md-icon style="color:#EA7C7C;">delete</md-icon>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
            <div v-if="pdfs.length <= 0" style="text-align: center;">
              <label>{{ options.Lang.keine_Daten_gefunden }}</label>
            </div>
          </div>
          <div v-else-if="tabChoice === 'general_documents'">
            <!--allgemeine pdfs-->
            <div v-if="allgemeinLoad">
              <table class="tableclass2-timeline" style="width: 100%;">
                <tr>
                  <td style="width: 30%; padding: 0; padding-left: 1rem;" class="name1">
                    {{options.Lang.Name}}
                  </td>
                  <td style="width: 30%;padding-left: 20px;" class="action">

                  </td>
                </tr>
              </table>
              <table class="formTD"  v-for="(pdf, index) in pdfsAllgemein" :key="index" style="width: 100%;">
                <tr v-if="pdf.showMe">
                  <td style="width: 40%; padding-left: 20px; padding-top: 1rem; padding-bottom: 1rem;">
                    {{ pdf.pdfname }}
                  </td>
                  <td style="width: 30%; padding-bottom: 1rem;">
                    <div class="md-layout-item">
                      <div class="switch-wrapper">
                        <label class="custom-switch">
                          <input type="checkbox" :checked="pdf.status"  @change="onToggle(pdf, $event)">
                          <span class="custom-slider"></span>
                        </label>
                        <span :id=" `label-pdf-${pdf.id}`" class="status-label" >{{ pdf.status ? options.Lang.aktiviert : options.Lang.deaktiviert }}</span>
                      </div>
                    </div>
                  </td>
                  <!-- <td>{{ pdf }}</td> -->
                  <td style="width: 30%; padding-right: 2rem;">
                    <a v-bind:href="'./' + pdf.pdf" target="_blank">
                      <div style="float: right; height: 40px; padding-top: 7px;">
                        <md-icon style="color:black;">travel_explore</md-icon>
                      </div>
                    </a>
                  </td>
                </tr>
              </table>
              <div v-if="pdfsAllgemein.length <= 0" style="text-align: center;">
                <br>
                <label>{{ options.Lang.keine_Daten_gefunden }}</label>
              </div>
              <br><br>
            </div>
          </div>
          <div v-else-if="tabChoice === 'upload_documents'" class="upload-section">
            <form novalidate class="upload-grid">
              <!-- Kategorie -->
              <div class="upload-item">
                <md-field class="md-focused">
                  <label for="categorie">
                    <strong>{{ options.Lang.Kategorie }}</strong>
                    <span class="asterix">*</span>
                  </label>
                  <md-select v-model="categorie" name="categorie" id="categorie">
                    <md-option v-for="(cat, index) in categories" :key="index" :value="cat.name" :id="cat.id" @change="getCat()">
                      {{ cat.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>
              <!-- Dateiname -->
              <div class="upload-item">
                <md-field class="md-focused">
                  <label for="filename">
                    <strong>{{ options.Lang.Name }}</strong>
                    <span class="asterix"></span>
                  </label>
                  <md-input v-model="fileName" name="fileName" id="fileName" required/>
                </md-field>
              </div>

              <!-- Datei auswählen -->
              <div class="upload-item">
                <md-field class="md-focused">
                  <label for="uploadFile">
                    <strong>{{ options.Lang.Pdf_wählen }}</strong>
                    <span class="asterix">*</span>
                  </label>
                  <input
                      class="test"
                      type="file"
                      @change="getUploadFile"
                      name="uploadFile"
                      id="uploadFile"
                      accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.oasis.opendocument.text"
                  />
                </md-field>
              </div>
            </form>
          </div>
        </div>
      </transition>
      <Error class="errorDialog" v-if="options.showError && options.user.loggedIn" :options="options"></Error>
    </md-dialog-content>
    <md-dialog-actions class="tab-actions-border">
      <md-button v-if="tabChoice === 'upload_documents'" tabindex="7" :disabled="!isLoaded" type="submit" class="md-raised md-primary trip-pdf-upload-button" @click="checkInput"><strong>{{ options.Lang.Hochladen }}</strong></md-button>
      <md-button tabindex="8" class="md-raised secondary" @click="closeDialog"><strong>{{options.Lang.Fenster_schließen}}</strong></md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import {validationMixin} from 'vuelidate'
import Error from '../../components/dialogs/Error.vue'
import SmallInfoBox from '@/components/parts/SmallInfoBox.vue'
import heightFadeTransition from '@/mixins/heightFadeTransition.js';

export default {
  name: 'formUploadPdf',
  mixins: [validationMixin, heightFadeTransition],
  components: {
    SmallInfoBox,
    Error
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    currentTrip: {
      type: Object
    },
  },
  data: () => ({
    test: false,
    trip: null,
    trip_details_json: null,
    tabChoice: 'trip_documents',
    Branding: null,
    brands: [],
    pdfs: [],
    pdfsAllgemein: [],
    pdfsAllgemeinToTrip: [],
    needDBEntry:[],
    allgemeinLoad: false,
    categories: [],
    uploadFile: null,
    fileName: null,
    categorie: null,
    isLoaded: false,
    Dpdf: null
  }),
  created() {
  },
  async mounted() {
    this.options.isUploading = true;
    //console.log(this.pdfs, "mypdfs")
    this.trip = this.currentTrip;
    this.trip_details_json = await this.loadJsonField('trip_details', this.trip.json_path);
    this.Branding = this.trip.Branding   
    //all pdfs to trip
    //console.log('mounted');
    //this.getAllPdfsToTrip();
    let self = this;
    await this.doPost({}, 'getAllCategoriesToPdf', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          self.options.isUploading = false;
          let result = res.data.data;
          self.categories = result;
          //console.log(self.categories, "cats")
        }
        });
    await this.doPost({}, 'getAllgemeinPdf', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        self.pdfsAllgemein = result;
        // console.log(self.pdfsAllgemein);
      }
    });
    await this.doPost({data: self.trip.nezasa_id}, 'getAllgemeinPdfTrip', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        self.pdfsAllgemeinToTrip = result;
        // console.log(self.pdfsAllgemeinToTrip, "pdfAllgemeinToTrip");

      }
    });
    await self.checkforTrip();
    await self.getModules();
  },
  watch: {
    currentTrip: {
      handler(newValue) {
        let self = this;
        if (newValue) {
          self.trip = newValue ? newValue : null;
          self.getAllPdfsToTrip();
        }
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    onToggle(pdf, event) {
      pdf.status = event.target.checked;
      const el = document.getElementById(`label-pdf-${pdf.id}`);
      if (el) {
        el.textContent = pdf.status ? this.options.Lang.aktiviert : this.options.Lang.deaktiviert;
      }
      this.handleSelectChange(pdf);  // backend call stays the same
    },
    async getModules(){
      let self = this;
      self.allgemeinLoad = false;
      self.brands = []
      await self.doPost({}, 'getAllBranding', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        // console.log(result)        
        for(let i = 0; i < result.length; i++){
          self.brands.push(result[i])
        
        }
        // console.log(self.brands, "modules")

        self.brands.forEach(brand =>{
          // alert(brand.adresse)
          // alert(self.Branding)

          if(brand.adresse == self.Branding){
            self.Branding = brand.id
          }
        })

        self.getBrandName();

      }
    });
    },
    async getBrandName(){
      let self = this;
      self.pdfsAllgemein.forEach(pdf =>{
        // alert(pdf.branding_id)
        // alert(self.Branding)
            if(pdf.branding_id == self.Branding){
              pdf.showMe = true
            }
        })
        // console.log(self.pdfsAllgemein, "mynewPdfs")
        self.allgemeinLoad = true;
    },
    async handleSelectChange(value) {
      let myData = {
        tripid: this.trip.nezasa_id,
        pdf: value
      }
      // console.log(myData)
      let self = this;

      await this.doPost({data: myData}, 'changeAllgemeinPdf', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          //alert("ready")
        }
      });
    },
    async checkforTrip(){
      this.pdfsAllgemein.forEach(allgemein =>{
          allgemein.status = "unset"
        })
      this.pdfsAllgemein.forEach(allgemein => {
        let found = false;
        this.pdfsAllgemeinToTrip.forEach(toTrip => {
          if(allgemein.pdf == toTrip.pdfallgemein){
            allgemein.status = toTrip.status;
            allgemein.status = allgemein.status == 0 ? false : true;
            found = true;
          }
        });

        // If no match found in trips, use the default status from allgemein
        if (!found) {
          allgemein.status = allgemein.defaultValue == 0 ? false : true;
          this.needDBEntry.push(allgemein);
        }
      });
      //console.log(this.pdfsAllgemein, "ende")

      this.pdfsAllgemein.forEach(allgemein => {
        if(allgemein.status == "unset"){
          this.needDBEntry.push(allgemein)
        } 
      })
      // console.log(this.needDBEntry, "need db entries")
      if(this.needDBEntry.length > 0){
        this.dbEntries()
      }else{
        this.pdfsAllgemein.forEach(allgemein =>{
          this.pdfsAllgemeinToTrip.forEach(toTrip => {
            if(allgemein.pdf == toTrip.pdfallgemein){
              allgemein.status = toTrip.status;
              allgemein.status = allgemein.status == 0 ? false  : true

            }
          })
        })
        // console.log(this.pdfsAllgemein, "ENDE SHORT")
        //this.allgemeinLoad = true;
      }
    },
    async dbEntries(){
      let myData = {
        tripid: this.trip.nezasa_id,
        pdfs: this.needDBEntry,
      }
      let self = this;
      await this.doPost({data: myData}, 'dbentryAllgemein', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          //alert("ready")
        }
      });
      await this.doPost({data: self.trip.nezasa_id}, 'getAllgemeinPdfTrip', function (res) {
      if (res.data.status === 'error') {
        self.help.log(self.$t(res.msg), false, true);
      } else {
        let result = res.data.data;
        self.pdfsAllgemeinToTrip = result;
        // console.log(self.pdfsAllgemeinToTrip, "pdfAllgemeinToTrip");
        self.pdfsAllgemein.forEach(allgemein =>{
          self.pdfsAllgemeinToTrip.forEach(toTrip => {
            if(allgemein.pdf == toTrip.pdfallgemein){
              allgemein.status = toTrip.status;
              allgemein.status = allgemein.status == 0 ? false  : true

            }
          })
        })
        // console.log(self.pdfsAllgemein, "ENDE LONG")
        //self.allgemeinLoad = true;
      }
    });
    },
    getAllPdfsToTrip(cb) {
      let self = this;
      self.isLoaded = false
      self.pdfs = [];
      let tripId = this.trip.offer_id;
      this.doPost({data: tripId}, 'getAllPdfsToTrip', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          let result = res.data.data;
          for (let i = 0; i < result.length; i++) {
            self.pdfs.push(result[i]);
          }
          self.isLoaded = true;
          if(cb){
            cb();
          }
        }
      });
      this.options.isUploading = false;
    },
    removePDF(pdfId) {
      this.pdfs.forEach(element =>{
        if(element.id == pdfId){
          this.Dpdf = element;
        }
      })
      //console.log(this.Dpdf, "DELEEEEEETE")
      this.options.isUploading = true;
      let self = this;
      self.doPost({data: this.Dpdf}, 'removePdf', function (res) {
        if (res.data.status === 'error') {
          self.help.log(self.$t(res.msg), false, true);
        } else {
          //do stuff
          self.refreshDialog();
        }
      })
    },
    checkInput(){
      if (this.uploadFile == null || this.fileName == null || this.categorie == null) {
        this.options.isUploading = false;
        this.options.showError = true;
        //this.refreshDialog();
      }else{
        this.uploadPDF();
      }
    },
    uploadPDF() {
     
      const item = this.categories.find((p) => p.name === this.categorie);
      this.categorie = item?.id;
      let test = item?.name;
      let self = this;
      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });

      async function Main(blub) {
        self.options.isUploading = true;
        const file = blub;
        let baseFile = await toBase64(file);

        let uploadData = {
          nezasaId: self.trip.nezasa_id,
          file: baseFile,
          pdfName: self.fileName,
          tripId: self.trip.offer_id,
          categorie: self.categorie,
          catName: test,
          fileExtension: "" 
        };

        let fileExtension = file.name.split('.').pop().toLowerCase();

        if (fileExtension !== 'pdf' && fileExtension !== 'doc' && fileExtension !== 'docx' && fileExtension !== 'odt') {
          // Ungültige Dateiendung
          self.options.isUploading = false;
          self.options.showError = true;
          return;
        }
        
        uploadData.fileExtension = fileExtension;

        uploadData.dir = 'pdfs/' + uploadData.nezasaId + '/' + uploadData.pdfName + '.' + fileExtension;
        uploadData.newDir = 'pdfs/' + uploadData.nezasaId + '/';

        
        let doubleEntrie = false;
        self.pdfs.forEach(element =>{
          if(element.pdfName == uploadData.pdfName){
            doubleEntrie = true
          }
        })

        //console.log(uploadData.file, "file frontend")
        if(doubleEntrie){
          self.options.isUploading = false;
          self.options.showError = true;
        }else{
          self.doPost({data: uploadData}, 'uploadPdfToTrip', function (res) {
          if (res.data.status === 'error') {
            self.help.log(self.$t(res.msg), false, true);
          } else {
            //do stuff
            self.getAllPdfsToTrip(self.refreshDialog);
          }
        });
        }
        
      }

      if (this.uploadFile == "" || this.fileName == "" || this.categorie == "") {
        //alert("nanuuuuu")
        this.options.s
        this.options.isUploading = false;
        this.refreshDialog();
      }else{
        Main(this.uploadFile);
      }
      
        
      
      
    },
    getUploadFile(event) {
      this.uploadFile = event.target.files[0];
    },
    getFileName(event) {
      this.fileName = event.target.value;
    },
    openDialog() {
      //do stuff
    },
    closeDialog() {
      this.options.showUploadPdfForm = false;
      this.options.currentTrip = null;
    },
    refreshDialog() {
      let self = this;
      self.options.showUploadPdfForm = false;
      self.$nextTick(() => {
        // Adding the component back in
        this.options.isUploading = false;
        self.options.showUploadPdfForm = true;
      });
    },
  }
}
</script>
<style lang="scss">
@use '../../assets/style/General/animations/heightFadeTransition.scss';
@use '../../assets/style/General/tab_layout.scss';

.updloadPdf-form-dialog .md-dialog-container {
  width: 1500px !important;
  max-width: 1500px !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .4s;
  transition: .4s;
}
.none{
  display: none;
}
.formTD {
  background-color: rgb(249, 249, 249);
  margin-bottom: 5px;
  vertical-align: bottom;
  border-collapse: collapse;
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #B6D210;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #B6D210 transparent transparent transparent;
}
.choose-file::file-selector-button:hover{
 cursor:pointer;
 background-color: #c9cbce;
}

.catTR td{
  background-color: white;
}

.label-container {
  display: flex;
  flex-wrap: wrap;
  column-gap: 22px;
}

.label-left,
.label-right {
  display: flex;
  flex-direction: column;
}

.label-left {
  margin-right: 30px;
}


.label-text {
  font-weight: bold;
  margin-bottom: 10px;
}

.nezasa-idPDF,
.trip-alias {
  border: 0.6000000238418579px solid #D5D5D5;
  border-radius: 4px;
  background: #F5F6FA 0% 0% no-repeat padding-box;
  
  padding: 18px;
  min-width: 292px;
  margin-bottom: 15px;
  ;
}

.trip-alias {
  min-width: 383px;
}

.asterix {
  color: #EA7C7C;
}

.md-field {
    margin: 4px 0px !important;
}

.md-field.md-required label:after{
  
    color: #EA7C7C !important;
    
}

.tableclass2-timeline {
  width: 100%;
  height: 48px;
  padding-left: 50px;
  vertical-align: center !important;
  border-collapse: collapse;
  background: #E1E8F3;
  opacity: 1;
  font-weight: bold;
  border-radius: 10px;
}

.formTD tr {
  padding: 5px;
  background-color: white !important;
  border-bottom: 0.4000000059604645px solid #97979767;
}

.test::file-selector-button {
    font-weight: bold;
    color: #202224;
    font-family: "Nunito", sans-serif !important;
    font-size: 14px !important;
    background-color: #E1E8F3;
    padding: 10px 24px;
    outline: none;
    border: none;
    border-radius: 10px;
    width: 155px;
    height: 38px;
    display: inline-block;
    margin-top: 8px;
}

.test::file-selector-button:hover{
 cursor:pointer;
 background-color: #c9cbce;
}

.md-dialog-content:first-child {
    padding-top: 24px;
    
}

.bearbeiter, .kunde {
  border: 0.6000000238418579px solid #D5D5D5;
  border-radius: 4px;
  background: #F5F6FA 0% 0% no-repeat padding-box;
  
  padding: 18px;
  min-width: 360px;
  margin-bottom: 15px;
  ;
}
.trip-pdf-upload-button{
  float: inline-end;
}

.pdf-upload-dialog-content{
  margin: 0 50px 50px 50px;
}
/* wrapper */
.switch-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* main switch container */
.custom-switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 20px;
}

/* hide native checkbox */
.custom-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* track (background bar) */
.custom-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f9c6c6;       /* OFF light pink */
  border-radius: 20px;
  transition: background-color .2s;
}

/* knob */
.custom-slider:before {
  content: "";
  position: absolute;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background-color: #f48c8c;       /* OFF pink knob */
  top: 2px;
  left: 22px;                      /* RIGHT side when OFF */
  transition: .2s;
}

/* ON STATE */
.custom-switch input:checked + .custom-slider {
  background-color: #b8f7d0;       /* light green */
}

.custom-switch input:checked + .custom-slider:before {
  left: 2px;                       /* move knob LEFT */
  background-color: #48d490;       /* green */
}

/* label text colors */
.status-label {
  font-size: 16px;
  font-weight: 500;
}

.status-active {
  color: #16c172;  /* green */
}

.status-inactive {
  color: #e98c8c;  /* red */
}
/* Section title spacing */
.upload-title {
  margin-bottom: 25px;
  margin-left: 10px;
}

/* Grid layout for the 3 input fields */
.upload-grid {
  display: flex;
  justify-content: center;   /* center horizontally */
  align-items: flex-start;
  gap: 60px;                 /* spacing between elements */
  width: 100%;
  margin-top: 10px;
  margin-bottom: 40px;
}

/* Ensures all fields are same width */
.upload-item {
  width: 450px;
}

/* Consistent spacing inside md-field */
.upload-item .md-field {
  width: 100%;
}

/* Fix for the choose-file button */
#uploadFile {
  margin-top: 6px;
}

</style>